import React, { useEffect, useState } from 'react';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import { PageLoader } from 'utils';
import RestServices from '../services/RestServices.js';

const withAuthentication = (Component) => {
   
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                authUser: null,
                role: null,
                allrole: null,
                loading: false,
                error: null,
                GiftCards: '',
                siteStatus: '',
                siteStatusColor: ''
            };
        }
       
        
        componentWillMount() {
            if (localStorage.getItem('FirebaseToken')) {
                if (window.location.pathname != '/deposite-confirmation') {
                  this.props.firebase.doSignOut();
                }
            }
            this.checkSession();
           
          
           
        }
        
        componentWillUnmount() {
           //this.listener();
           this.checkSession();
        }
        
        doSomethingBeforeUnload = () => {
            let dataRow = {
                FirebaseToken: localStorage.getItem('FirebaseToken')
            };
            RestServices.doLogOut( dataRow )
                .then((response) => response.json())
                .then(async (responseData) => {
                })
        }
         
         
        checkSession=()=>{
            window.addEventListener('beforeunload', (event) => {
                
                console.log('event',event)
                // Cancel the event as stated by the standard.
                event.preventDefault();
                // Chrome requires returnValue to be set.
                event.returnValue = '';
                this.doSomethingBeforeUnload()
              });

            

            window.addEventListener('storage', (event) => {

                if (event.target.localStorage && event.target.localStorage.FirebaseToken) {
                    this.setState({ loading: true });
                    let dataRow = {
                        FirebaseToken: event.target.localStorage.FirebaseToken
                    };
                    RestServices.getSignInUserDetail(
                        event.target.localStorage.FirebaseToken,
                        dataRow
                    )
                        .then((response) => response.json())
                        .then(async (responseData) => {
                            if (responseData.error) {
                                this.setState({
                                    loading: false,
                                    error: responseData.error
                                });
                            } else {
                                this.setState({
                                    siteStatus: responseData.siteStatus,
                                    siteStatusColor: responseData.textColor
                                });

                                if (responseData.Roles) {
                                    this.setState({
                                        allrole: responseData.Roles
                                    });
                                    if (
                                        responseData.Roles.length > 1 &&
                                        localStorage.getItem(
                                            'WitchloginAs'
                                        ) &&
                                        localStorage.getItem(
                                            'WitchloginAs'
                                        ) != ''
                                    ) {
                                        this.setState({
                                            role: localStorage.getItem(
                                                'WitchloginAs'
                                            )
                                        });
                                        this.setState({
                                            error: null,
                                            loading: false,
                                            authUser: responseData
                                        });
                                    } else if (
                                        responseData.Roles.length > 1 &&
                                        localStorage.getItem('loginAs') &&
                                        localStorage.getItem('loginAs') !=
                                            ''
                                    ) {
                                        this.setState({
                                            role: localStorage.getItem(
                                                'loginAs'
                                            )
                                        });
                                        this.setState({
                                            error: null,
                                            loading: false,
                                            authUser: responseData
                                        });
                                    } else {
                                        if (
                                            responseData.Roles.indexOf(
                                                'Admin'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'Admin'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'Admin'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else if (
                                            responseData.Roles.indexOf(
                                                'GManager'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'GManager'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'GManager'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else if (
                                            responseData.Roles.indexOf(
                                                'Employees'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'Employees'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'Employees'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else if (
                                            responseData.Roles.indexOf(
                                                'Distributors'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'Distributors'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'Distributors'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else if (
                                            responseData.Roles.indexOf(
                                                'StoreCP'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'StoreCP'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'StoreCP'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else if (
                                            responseData.Roles.indexOf(
                                                'StoreOwners'
                                            ) > -1
                                        ) {
                                            this.setState({
                                                role: 'StoreOwners'
                                            });
                                            localStorage.setItem(
                                                'loginAs',
                                                'StoreOwners'
                                            );
                                            this.setState({
                                                error: null,
                                                loading: false,
                                                authUser: responseData
                                            });
                                        } else {
                                            this.setState({
                                                loading: false,
                                                error: 'Your account is not activated yet, Please contact admin...'
                                            });
                                        }
                                    }

                                    let dataRowBH = {
                                        UserRole: localStorage.getItem(
                                            'WitchloginAs'
                                        )
                                            ? localStorage.getItem(
                                                  'WitchloginAs'
                                              )
                                            : localStorage.getItem(
                                                  'loginAs'
                                              ),
                                        UniqeID: responseData.ProfileUniqeID
                                    };
                                    //console.log(dataRowBH)
                                    RestServices.getAssignedGiftCards(
                                        event.target.localStorage.FirebaseToken,
                                        dataRowBH
                                    )
                                        .then((response) => response.json())
                                        .then((responseData) => {
                                            if (responseData.selectedGC) {
                                                localStorage.setItem(
                                                    'GiftCards',
                                                    responseData.selectedGC
                                                );
                                                this.setState({
                                                    GiftCards:
                                                        responseData.selectedGC
                                                });
                                            }
                                        });
                                } else {
                                    this.setState({
                                        loading: false,
                                        error: 'Your account is not activated yet, Please contact admin...'
                                    });
                                }
                            }
                        });
                }else{
                    if (
                        window.location.pathname ==
                            '/transaction-history' ||
                        window.location.pathname == '/termsofuse' ||
                        window.location.pathname == '/privacy' ||
                        window.location.pathname == '/cookie-policy' ||
                        window.location.pathname == '/faq' ||
                        window.location.pathname == '/contact-us' ||
                        window.location.pathname == '/sign-up' ||
                        window.location.pathname == '/deposite-confirmation'
                    ) {
                    } else if (window.location.pathname != '/signin') {
                        window.location.replace('signin');
                    }
                }
            });
        }
        render() {
            if (this.state.loading) {
                return <PageLoader />;
            }

            if (this.state.error) {
                return (
                    <div className="internet-error">
                        <p>{this.state.error}</p>
                    </div>
                );
            }
            return (
                <>
                    <AuthUserContext.Provider
                        value={[
                            this.state.authUser,
                            this.state.role,
                            this.state.GiftCards,
                            this.state.siteStatus,
                            this.state.siteStatusColor
                        ]}
                    >
                        <Component
                            {...this.props}
                            authUser={this.state.authUser}
                            GiftCards={this.state.GiftCards}
                            role={this.state.role}
                            allrole={this.state.allrole}
                            siteStatus={this.state.siteStatus}
                            siteStatusColor={this.state.siteStatusColor}
                        />
                    </AuthUserContext.Provider>
                </>
            );
        }
    }

    return withFirebase(WithAuthentication);
};

export default withAuthentication;
